import React, { useEffect, useState } from "react";
import Div100vh from "react-div-100vh";

import DynamicInputForm from "@/components/common/DynamicInputForm.jsx";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import Header from "@/components/common/Header/header";
// Was mistakenly `import { config } from "dotenv"` — dotenv's `config` is a FUNCTION, so
// `config.OTP_LENGTH` was silently undefined. This is the real app config module (src/config.js).
import config from "@/config";
import CustomDrawer from "../common/drawer";
import GoBackButton from "../common/buttons/GoBackButton";
import OTPInput from "react-otp-input";
import {
  isValidEmail,
  isValidPANCard,
  isWorkEmail,
  updateFunction,
} from "@/lib/helper";
import { data } from "autoprefixer";
import Loader from "../common/Loader";
import { useNavigate } from "react-router-dom";
import { trackConsent } from "@/lib/apis";

const salariedConfg = [
  {
    type: "text",
    label: "Employer Name",
    name: "companyName",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "text",
    label: "Job Role/Designation",
    name: "designation",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "autocomplete_address",
    label: "Office Address",
    name: "officeAddress",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "email",
    label: "Work Email",
    name: "workEmail",
    required: true,
    pattern: "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,}",
  },
  // {
  //   type: "date",
  //   label: "Joining date",
  //   name: "joining_date",
  //   required: true,
  // },
];

const selfEmployedConfig = [
  {
    type: "text",
    label: "Business Name",
    name: "companyName",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "autocomplete_address",
    label: "Office Address",
    name: "officeAddress",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "text",
    label: "Business Income",
    name: "businessIncome",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
];

const studentConfig = [
  {
    type: "text",
    label: "College Name",
    name: "companyName",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "text",
    label: "Father/Mother Name",
    name: "coApplicantName",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "text",
    label: "Co-Applicant PAN",
    name: "coApplicantPan",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
  {
    type: "number",
    label: "Co-Applicant Phone",
    name: "coApplicantPhone",
    required: true,
    pattern: "^d{10}$",
  },
];

export default function WorkDetails() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [activeChip, setActiveChip] = useState("SALARIED");

  const chips = ["SALARIED", "SELF_EMPLOYED", "STUDENT"];

  const [verifying, setVerifying] = useState(false);
  const [otpDrawer, setOtpDrawer] = useState(false);
  const [newOtpSent, setNewOtpSent] = useState(false);

  const [otp, setOtp] = useState("");
  const [otpError, setotpError] = useState("");

  // useEffect(() => {
  //   if (error || otpError || otp) {
  //     setError("");
  //     setotpError("");
  //   }
  //   if (otp.length === config.OTP_LENGTH) {
  //     handleVerifyOtp(otp);
  //   }
  // }, [otp]);

  useEffect(() => {
    console.log(otp);
  }, [otp]);

  const handleResendOtp = async () => {
    try {
      setOtp("");
      setVerifying(true);
      await updateFunction({ email: formData?.workEmail }, "user/send-email");
      // toast({
      //   variant: "destructive",
      //   title: "Error",
      //   description: data.message,
      // });
      setNewOtpSent(true);
    } catch (error) {
      setError(error?.message || "Please try again after some time.");
      setOtpDrawer(false);
    } finally {
      setVerifying(false);
    }
  };

  const sendWorkDetails = async () => {
    setLoading(true);
    try {
      const res = await updateFunction(formData, "user/work-details");
      // log(res)
      if (res.status === "success") {
        setLoading(false);
        navigate("/onboarding");
      } else {
        setError(res.message);
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    console.log(otp);

    try {
      setVerifying(true);
      const response = await updateFunction(
        {
          otp: `${otp}`,
        },
        "user/verify-email"
      );

      if (response.status === "success") {
        setVerifying(false);
        setOtpDrawer(false);
        await sendWorkDetails();
        const platform =
          navigator?.userAgentData?.platform ||
          navigator.platform ||
          localStorage.getItem("UTM_SOURCE");
        await trackConsent(
          "OTP",
          "Work Email",
          formData.workEmail,
          platform,
          ""
        );
      } else {
        setotpError(response.message);
      }
    } catch (error) {
      setotpError(error?.message || "Please try again after some time.");
    } finally {
      setVerifying(false);
    }
  };

  const handelClick = async () => {
    // if (error !== null || error !== "") return;
    if (
      activeChip === "SALARIED" &&
      formData?.companyName &&
      formData?.designation &&
      formData?.officeAddress &&
      formData?.workEmail
    ) {
      const isWorkEmailValid = await isWorkEmail(formData.workEmail);

      if (isValidEmail(formData?.workEmail) && isWorkEmailValid) {
        //call some api
        setLoading(true);
        try {
          await updateFunction(
            { email: formData?.workEmail },
            "user/send-email"
          );
        } catch (error) {
          setError(error);
        } finally {
          setLoading(false);
        }
        setOtpDrawer(true);
      } else {
        setError("Please enter valid Work Email");
      }
    } else if (
      activeChip == "SELF_EMPLOYED" &&
      formData?.companyName &&
      formData?.businessIncome &&
      formData?.officeAddress
    ) {
      //call some api
      await sendWorkDetails();
    } else if (
      activeChip == "STUDENT" &&
      formData?.companyName &&
      formData?.coApplicantName &&
      formData?.coApplicantPan &&
      formData?.coApplicantPhone
    ) {
      //call some api
      await sendWorkDetails();
    } else {
      setError("All Fields are Required");
    }
  };

  return (
    <Div100vh className="flex flex-col justify-between py-4 px-6 overflow-scroll">
      <Header
        heading="Work Details"
        subheading="We need these details to verify your employment details"
      />
      <div className="flex flex-col justify-start h-full  gap-4">
        <span className="text-[#999999] font-normal text-sm mt-6">
          Select Employment Type
        </span>
        <div className="flex space-x-2 mb-2">
          {chips.map((chip) => (
            <button
              key={chip}
              onClick={() => {
                setActiveChip(chip);
              }}
              className={`px-4 py-2 text-2xs font-medium ${
                activeChip === chip
                  ? "bg-white text-black"
                  : "bg-gray-800 text-white"
              } transition`}
            >
              {chip.replace("_", " ")}
            </button>
          ))}
        </div>
        <div>
          {activeChip === "SALARIED" && (
            <DynamicInputForm
              formConfig={salariedConfg}
              formData={formData}
              setFormData={setFormData}
              setError={setError}
            />
          )}
          {activeChip === "SELF_EMPLOYED" && (
            <DynamicInputForm
              formConfig={selfEmployedConfig}
              formData={formData}
              setFormData={setFormData}
              setError={setError}
            />
          )}
          {activeChip === "STUDENT" && (
            <DynamicInputForm
              formConfig={studentConfig}
              formData={formData}
              setFormData={setFormData}
              setError={setError}
            />
          )}
          {error && (
            <div className="w-full p-2 px-4 bg-red-400/10 text-red-400 rounded-lg mt-4">
              {error}
            </div>
          )}
        </div>
      </div>
      <CustomDrawer isOpen={otpDrawer} removePadding>
        <div className="p-8">
          <GoBackButton customBackSubmit={() => setOtpDrawer(false)} />
          <div className="w-full text-left  ">
            <div className="heading mb-2 mt-12 ">Enter OTP</div>
            <div className="subheading font-light text-sm">
              Sent to{" "}
              <span className="font-light text-sm">
                {formData?.workEmail || "your email"}
              </span>{" "}
              <span
                onClick={() => setOtpDrawer(false)}
                className="underline font-medium text-[#ccc] text-sm"
              >
                EDIT
              </span>
            </div>
          </div>
          <div className="flex-grow overflow-auto mt-5">
            <OTPInput
              className="rounded-none"
              inputType="tel"
              value={otp}
              numInputs={config.OTP_LENGTH}
              onChange={setOtp}
              containerStyle={{
                display: "flex",
                justifyContent: "center",
              }}
              isInputNum={true}
              renderInput={(props) => (
                <input
                  {...props}
                  type="tel"
                  style={{ border: "1px solid #444", margin: "4px" }}
                  className="border-[#999] border w-10 h-12 text-center text-lg bg-transparent justify-around"
                />
              )}
              pattern="[1-9]{1}[0-9]{9}"
              shouldAutoFocus
            />
            {otpError && (
              <div className="w-full p-2 px-4 bg-red-400/10 text-red-400 rounded-lg">
                {otpError}
              </div>
            )}
            {!verifying && (
              <div className="w-full p-4">
                <div className="text-center subheading text-sm">
                  <span>
                    {newOtpSent
                      ? "New OTP has been sent, try again if not received?"
                      : "Didn't get the code?"}
                  </span>
                  <span> </span>
                  <span
                    onClick={() => handleResendOtp()}
                    className="font-semibold cursor-pointer text-[#ccc] text-sm"
                  >
                    Resend it
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="pt-6">
            {verifying ? (
              <Loader />
            ) : (
              <PrimaryButton
                text="Verify"
                handleClick={() => handleVerifyOtp()}
                disabled={otp?.length < config.OTP_LENGTH}
              />
            )}
          </div>
        </div>
      </CustomDrawer>

      {loading ? (
        <Loader />
      ) : (
        <PrimaryButton
          text={"Confirm"}
          handleClick={handelClick}
          // error={error}
          // disabled={loading}
        />
      )}
    </Div100vh>
  );
}
